import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
	Modal,

} from 'react-bootstrap';
// import classNames from 'classnames';
import { ToastContainer, toast } from 'react-toastify';
// import ReactLoading from 'react-loading';
import 'react-toastify/dist/ReactToastify.css';
import { bindActionCreators } from 'redux';
import * as signinActions from '../../actions/signinActions';
// import * as SVGICONS from '../../images/img/images';

// import Modal from 'react-modal';
import validator from './validator';
const autoBind = require('auto-bind');
// This is a class-based component because the current
// component at the top-level.
class ResetPassword extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			resetkey: '',
			patternOne: false,
			patternTwo: false,
			patternThree: false,
			patternFour: false,
			popoverShow: false,
			spinner: false,
			// currentPassword: { value: '', isValid: true, message: '' },
			password: { value: '', isValid: true, message: '' },
			cpassword: { value: '', isValid: true, message: '' }
		};
		// this.openSignInModal = this.openSignInModal.bind(this);
		// this.hideSigninModal = this.hideSigninModal.bind(this);
		// this.openResetPasswordModal = this.openResetPasswordModal.bind(this);
		// this.hideResetPasswordModal = this.hideResetPasswordModal.bind(this);
		this.onPasswordSettingChange = this.onPasswordSettingChange.bind(this);
		this.resetValidationStates = this.resetValidationStates.bind(this);
		this.resetPassword = this.resetPassword.bind(this);
		// this.closeResetModal = this.closeResetModal.bind(this);
	}
	// closeResetModal() {
	// 	browserHistory.push("/")
	// }
	componentWillMount() {
		this.setState({ resetkey: this.props.resetkey })
	}
	// componentDidMount() {
	// 	this.setState({ isLoader: false });
	// }

	// openResetPasswordModal() {
	// 	this.setState({ signUpModelOpen: true });
	// }
	// hideResetPasswordModal() {
	// 	this.setState({ signUpModelOpen: false });
	// }
	onPasswordSettingChange(e) {
		var state = this.state;
		state[e.target.name].value = e.target.value;
		this.resetValidationStates();
		if (e.target.name == "password") {
			this.setState({ popoverShow: true })
			if (e.target.value.length > 0) {
				if ((validator.atLeastOneLetter(state.password.value)) || (validator.atLeastOneCapitalLetter(state.password.value)) || (validator.atLeastOneNumber(state.password.value)) || (validator.atLeastEightCharacters(state.password.value))) {
					if (validator.atLeastOneLetter(state.password.value)) {
						state.patternOne = true;
					} else {
						state.patternOne = false;
					}
					if (validator.atLeastOneCapitalLetter(state.password.value)) {
						state.patternTwo = true;
					} else {
						state.patternTwo = false;
					}
					if (validator.atLeastOneNumber(state.password.value)) {
						state.patternThree = true;
					} else {
						state.patternThree = false;
					}
					if (validator.atLeastEightCharacters(state.password.value)) {
						state.patternFour = true;
					} else {
						state.patternFour = false;
					}
				} else {
					return true
				}
				if (state.patternOne && state.patternTwo && state.patternThree && state.patternFour) {
					state.password.isValid = true;
					state.password.message = '';
					state.popoverShow = false;
				} else {
					state.password.isValid = false;
					state.password.message = 'Not a valid password';
					state.popoverShow = true;
				}
			} else {
				state.patternOne = false;
				state.patternTwo = false;
				state.patternThree = false;
				state.patternFour = false;
				state.password.isValid = false;
				state.password.message = 'Password is required';
				state.popoverShow = false;
			}
		} else if (e.target.name == "cpassword") {
			if (e.target.value.length > 0) {
				if (state.password.value != state.cpassword.value) {
					state.cpassword.isValid = false;
					state.cpassword.message = 'Passwords do not match';
					this.setState(state);
				} else {
					return true
				}
			} else {
				state.cpassword.isValid = false;
				state.cpassword.message = 'Confirm password is required';
				this.setState(state);
			}

		} else
			if (e.target.name == "currentPassword") {
				if (e.target.value.length > 0) {
					if (!validator.isValid(state.currentPassword.value)) {
						state.currentPassword.isValid = false;
						state.currentPassword.message = 'Not a valid currentPassword';
						this.setState(state);
					} else {
						return true
					}
				} else {
					state.currentPassword.isValid = false;
					state.currentPassword.message = 'Current Password is required';
					this.setState(state);
				}
			}
		this.setState(state);
	}

	resetPassword(event) {
		event.preventDefault();
		var state = this.state;
		if (state.password || !state.password) {
			this.setState({ popoverShow: true })
			if (state.password.value.length > 0) {
				if ((validator.atLeastOneLetter(state.password.value)) || (validator.atLeastOneCapitalLetter(state.password.value)) || (validator.atLeastOneNumber(state.password.value)) || (validator.atLeastEightCharacters(state.password.value))) {
					if (validator.atLeastOneLetter(state.password.value)) {
						state.patternOne = true;
					} else {
						state.patternOne = false;
					}
					if (validator.atLeastOneCapitalLetter(state.password.value)) {
						state.patternTwo = true;
					} else {
						state.patternTwo = false;
					}
					if (validator.atLeastOneNumber(state.password.value)) {
						state.patternThree = true;
					} else {
						state.patternThree = false;
					}
					if (validator.atLeastEightCharacters(state.password.value)) {
						state.patternFour = true;
					} else {
						state.patternFour = false;
					}
				} else {
					state.password.isValid = true;
					state.password.message = '';
				}
				if (state.patternOne && state.patternTwo && state.patternThree && state.patternFour) {
					state.password.isValid = true;
					state.password.message = '';
					state.popoverShow = false;
				} else {
					state.password.isValid = false;
					state.password.message = 'Not a valid password';
					state.popoverShow = true;
				}
			} else {
				state.patternOne = false;
				state.patternTwo = false;
				state.patternThree = false;
				state.patternFour = false;
				state.password.isValid = false;
				state.password.message = 'Password is required';
				state.popoverShow = false;
			}
		} if (state.cpassword || !state.cpassword) {
			if (state.cpassword.value.length > 0) {
				if (state.password.value != state.cpassword.value) {
					state.cpassword.isValid = false;
					state.cpassword.message = 'Passwords do not match';
					this.setState(state);
				} else {
					state.cpassword.isValid = true;
					state.cpassword.message = '';
				}
			} else {
				state.cpassword.isValid = false;
				state.cpassword.message = 'Confirm password is required';
				this.setState(state);
			}

		}
		if (this.state.cpassword.value != '' && this.state.password.value != '' && (this.state.password.message == '' || this.state.password.message == undefined) && (this.state.cpassword.message == '' || this.state.cpassword.message == undefined) && (this.state.patternOne == true) && (this.state.patternTwo == true) && (this.state.patternThree == true) && (this.state.patternFour == true)) {

			let passwordObj = {
				resetkey: this.state.resetkey,
				password: this.state.password.value
			}
			this.props.actions.resetPassword(passwordObj);
			this.setState({
				cpassword: { value: '' },
				password: { value: '' },
				popoverShow: false,
				spinner: true
			})
		}

	}
	resetValidationStates() {
		var state = this.state;
		Object.keys(state).map(key => {
			if (state[key].hasOwnProperty('isValid')) {
				state[key].isValid = true;
				state[key].message = '';
			}
		});
		this.setState(state);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.resetData.success) {
			this.setState({ spinner: false })
			this.props.closeReset();
		} else {
			this.setState({ spinner: false });
		}
	}

	render() {
		return (

			<Modal show={this.props.resetModalOpen} size="modal-sm" onHide={this.props.closeReset}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.closeReset} /> */}
					<Modal.Title><img src={require('../../images/images/reset_passwrd.svg')} alt="" /></Modal.Title>
					{/* <img src={require('../../images/images/logo.svg')} alt="" /> */}
				</Modal.Header>
				<Modal.Body>
					{/* <ToastContainer /> */}
					<form className="signup-form" id="loginForm" onSubmit={this.resetPassword}>
						<div className="signIn changePass" style={{ "fontSize": "21" }}>Change password</div>


						<div className="loginInput">
							<div className="input-group">
								<div className="input-group-prepend">
									<span className="input-group-text" id="inputGroupPrepend">

									</span>
								</div>
								<input type="password" name="password" className="form-control"
									placeholder="Password" value={this.state.password.value} onChange={this.onPasswordSettingChange} />
								<span className="help-block">{this.state.password.message}</span>
								{this.state.popoverShow == true ? <div className="toolTip">
									<div className="tool_box">
										<p>Password must Meet the following requirements: </p>
										<ul>
											<li>{this.state.patternOne == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>} At least one letter</li>
											<li>{this.state.patternTwo == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one capital letter</li>
											<li>{this.state.patternThree == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one number</li>
											<li>{this.state.patternFour == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}Be at least 8 characters	</li>
										</ul>
									</div>
								</div> : ''}
							</div>

							<div className="input-group">
								<div className="input-group-prepend">
									<span className="input-group-text" id="inputGroupPrepend">

									</span>
								</div>
								<input type="password" className="form-control" id="cpassword" ref="cpassword" name="cpassword" placeholder="Confirm Password" value={this.state.cpassword.value} onChange={this.onPasswordSettingChange} />
								<span className="help-block">{this.state.cpassword.message}</span>
							</div>
							<div className="btngrouplogIn ">
								<button onClick={this.props.closeResetOpenSigin} className="btn btn-primary btn-signup pull-left" data-toggle="modal">{"<"}Back</button>
								<button type="submit" className="btn btn-primary btn-signup pull-right" data-toggle="modal" >Reset {this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
							</div>
						</div>
						{/* <div className="signIn">Change Password</div>
													<p className="signUp">Already have an account?<Link href="#" >Sign In</Link></p>
													<div className="input-group">
														<div className="input-group-prepend">
															<span className="input-group-text" id="inputGroupPrepend">
																<SVGICONS.PasswordSvg />
															</span>
														</div>
														<input type="password" name="password" className="form-control"
															placeholder="Password" value={this.state.password.value} onChange={this.onPasswordSettingChange} />
														<span className="help-block">{this.state.password.message}</span>
														{this.state.popoverShow == true ? <div className="toolTip">
															<div className="tool_box">
																<p>Password must Meet the following requirements: </p>
																<ul>
																	<li>{this.state.patternOne == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>} At least one letter</li>
																	<li>{this.state.patternTwo == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one capital letter</li>
																	<li>{this.state.patternThree == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one number</li>
																	<li>{this.state.patternFour == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}Be at least 8 characters	</li>
																</ul>
															</div>
														</div> : ''}
													</div>
													<div className="input-group">
														<div className="input-group-prepend">
															<span className="input-group-text" id="inputGroupPrepend">
																<SVGICONS.PasswordSvg />
															</span>
														</div>
														<input type="password" className="form-control" id="cpassword" ref="cpassword" name="cpassword" placeholder="Confirm Password" value={this.state.cpassword.value} onChange={this.onPasswordSettingChange} />
														<span className="help-block">{this.state.cpassword.message}</span>
													</div>
													<div className="btngrouplogIn">
														<button type="submit" className="btn btn-warning btn-lg">Update</button>
													</div> */}
					</form>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
function mapStateToProps(state, ownProps) {
	return {
		resetData: state.signin.resetData
	};
}

// bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(signinActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
// export default ResetPassword;
